<div class="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
  aria-labelledby="staticBackdropLabel" aria-hidden="true" [ngClass]="{ 'show': isOpen, 'd-block': isOpen }"
  style="z-index: 200000; margin-top: 200px" s>
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="staticBackdropLabel" style="font-size: 18px; font-weight: 600; color: #319197">
          {{title}}
        </h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
          (click)="closeModal()"></button>
      </div>
      <div class="modal-body">
        <p style="color: #319197; font-size: 14px">
          {{message}}
        </p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn" data-bs-dismiss="modal" (click)="closeModal()"
          style="color: #fff; background-color: #319197">
          Ok
        </button>
      </div>
    </div>
  </div>
</div>